// extracted by mini-css-extract-plugin
module.exports = {"jpg-postgresql-lock":"document_jpg-postgresql-lock__3c8Q3","quote":"document_quote__5URKf","jpg-filesystem":"document_jpg-filesystem__1Klt9"};